// General imports
import "./components";
import "./initializers";
import "./template";
import "./vue";

const version_deploy = "09/04/2026 16:38'";
// console.log("Version deployed: " + version_deploy);
